import TextField from "@mui/material/TextField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

interface DatePickerProps<T> {
  value: T | null;
  onChange: (newValue: Dayjs | null) => void;
  disablePast?: boolean;
  disableFuture?: boolean;
  dateFormat?: string;
}

const CustomDatePicker = <T extends Dayjs | null>({
  value,
  onChange,
  disablePast = false,
  disableFuture = false,
  dateFormat = "YYYY-MM-DD",
}: DatePickerProps<T>) => {
  const handleKeyDown = (event: any) => {
    event.preventDefault(); // Prevent any keyboard input
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={value}
        onChange={onChange}
        inputFormat={dateFormat} // Use the provided date format or default one
        disableFuture={disableFuture}
        disablePast={disablePast}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              onKeyDown: handleKeyDown,
            }}
            sx={{
              backgroundColor: "var(--white)",
              borderRadius: "6px",
              boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.05)",
              width: "100%", // Ensure the input takes up the full width
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
              "& .MuiInputBase-input": {
                padding: "10px 14px",
              },
            }}
          />
        )}
        // Ensure dropdown/modal opens properly
        PopperProps={{
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                boundary: "viewport", // Prevent dropdown from overflowing
              },
            },
            {
              name: "offset",
              options: {
                offset: [-16, 4], // Adjust this value to add a gap between input and dropdown
              },
            },
            {
              name: "flip",
              options: {
                enabled: true, // Allow dropdown to flip if there's insufficient space
              },
            },
          ],
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
